import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

import CheckIcon from '@mui/icons-material/Check';

import {
  isTest,
} from '../../../redux/challengeSlice';

export default function LoginSuccess() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signinResultState = useSelector((state) => state.challenge.signinResult);
  const isTestState = useSelector((state) => state.challenge.isTest);

  useEffect(() => {
    challengeSuccessTimer();
  }, []);

  const challengeSuccessTimer = () => {
    // setDisableButtons(true);
    setTimeout(() => {
      // resetChallenge();
      if (isTestState) {
        dispatch(isTest(false));
        // navigate("/challenge");
        navigate("/register-pattern");
      } else {
        // navigate("/challenge");
        navigate("/home");
      }
    }, 2000);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgb(23 163 74)',
            color: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '250px',
          }}
        >
          <Box>
            <CheckIcon
              sx={{
                color: '#FFFFFF',
                fontSize: '8rem',
              }}
            />
          </Box>
          <Typography
            variant='h4'
          >
            Pattern Accepted
          </Typography>
          {isTestState ?
            <Typography
              variant='body1'
            >
              This was a test. Now save your pattern.
            </Typography>
            : null
          }
        </Box>
      </Box>
    </React.Fragment>
  );

}